export enum PERSISTED_STATE_STORAGE_KEYS {
    SITE_STATE = 'roompulse.site.state.2.0',
    // The Full width choice of the Date based table, per browser.
    RATES_TABLE_FULL_WIDTH = 'roompulse.rates.table.full-width',
    // The Full width choice of the BI reports (one choice for every report), per browser.
    BI_FULL_WIDTH = 'roompulse.bi.full-width',
    // The View by choice of the BI reports with company groups (Groups or the single items), per report and browser.
    BI_SEGMENTATION_VIEW = 'roompulse.bi.segmentation.view',
    BI_CHANNELS_VIEW = 'roompulse.bi.channels.view',
}

const useWebStorage = () => {
    const setItem = <T>(name: string, value: T): void => {
        return localStorage.setItem(name, JSON.stringify(value));
    }

    const getItem = <T>(name: string): T | null => {
        const val = localStorage.getItem(name);
        if (val == null) return null;
        return <T>JSON.parse(val);
    }

    const removeItem = (name: string) => {
        return localStorage.removeItem(name);
    }

    return {
        setItem: setItem,
        getItem: getItem,
        removeItem: removeItem
    }
}

export default useWebStorage;
